import { ArrowRight } from "lucide-react";

export default function ItemsShowcase({ content, items }) {
  const sec = content?.items_section || {};

  return (
    <section id="itens" className="relative py-20 md:py-28 bg-cream overflow-hidden" data-testid="items-section">
      <div className="absolute inset-0 dot-pattern opacity-40" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block font-display text-sm font-semibold tracking-[0.2em] uppercase mb-4" style={{ color: "var(--ff-peach)" }}>
            {sec.eyebrow || "Os Nossos Itens"}
          </span>
          <h2 className="title-pop text-4xl md:text-6xl mb-4" style={{ color: "var(--ff-text)" }}>
            {sec.title || "Diversão em três sabores"}
          </h2>
          <p className="max-w-xl mx-auto text-base md:text-lg font-body" style={{ color: "var(--ff-text-soft)" }}>
            {sec.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {items.map((it, idx) => (
            <article
              key={it.slug}
              className="group flex flex-col items-center text-center"
              data-testid={`item-card-${it.slug}`}
            >
              <div
                className={`frame-scallop hover-zoom w-full max-w-sm ${idx % 2 === 1 ? "frame-scallop-blue" : ""}`}
                style={idx === 2 ? { background: it.color } : {}}
              >
                <div className="frame-inner aspect-square hover-zoom-img">
                  <img
                    src={it.image_url}
                    alt={it.name}
                    className="w-full h-full object-cover"
                    data-testid={`item-image-${it.slug}`}
                    onError={(e) => { e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23f1f5f9' width='400' height='300'/%3E%3Ctext fill='%2394a3b8' font-family='sans-serif' font-size='16' x='200' y='150' text-anchor='middle' dominant-baseline='middle'%3ESem imagem%3C/text%3E%3C/svg%3E"; }}
                  />
                </div>
              </div>

              <h3 className="title-pop text-2xl md:text-3xl mt-8 mb-3" style={{ color: "var(--ff-text)" }}>
                {it.name}
              </h3>
              <p className="font-body text-base mb-3 max-w-xs" style={{ color: "var(--ff-text-soft)" }}>
                {it.short_description}
              </p>
              <div
                className="inline-block font-display font-semibold text-sm rounded-full px-4 py-1.5 mb-5"
                style={{ background: "var(--ff-butter)", color: "var(--ff-text)" }}
              >
                {it.price_text}
              </div>
              <a
                href="#reservar"
                className="inline-flex items-center gap-2 font-display font-semibold hover-zoom"
                style={{ color: "var(--ff-peach)" }}
                data-testid={`item-cta-${it.slug}`}
              >
                Reservar este item <ArrowRight size={18} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
